module.exports = __webpack_public_path__ + "img/vidtobloglogo.def522cb.png";